import Vue from 'vue'
import App from './App'
import router from './router'
// import fastClick from 'fastclick'
import Cube from 'cube-ui' //cube-ui
import 'swiper/dist/css/swiper.css' //swiper css
import VueAwesomeSwiper from 'vue-awesome-swiper' //swiper
import './assets/styles/reset.css' //样式重置文件
import './assets/styles/border.css' //一像素边框
import 'jquery'
import './assets/iconfont/iconfont.css'
import VueScroller from 'vue-scroller'
import store from './../static/js/store'
// import { callWeChat } from './../static/js/weChat'
import { getUserOpenId } from './../static/js/openId'
import { Toast, Dialog } from 'vant';


// import Vconsole from 'vconsole'
// new Vconsole()





import echarts from 'echarts'
Vue.prototype.$echarts = echarts




Vue.use(Toast);
Vue.use(Dialog);
Vue.use(VueScroller)
Vue.config.productionTip = false
    // fastClick.attach(document.body) //解决移动端点击300毫秒延迟问题
Vue.use(Cube)
Vue.use(VueAwesomeSwiper)



Vue.prototype.unknownState = store.state.unknownState //未知/其他
Vue.prototype.diaryState = store.state.diaryState //日记
Vue.prototype.goodsState = store.state.goodsState //商品
Vue.prototype.homeState = store.state.homeState //首页
Vue.prototype.questionState = store.state.questionState //问答
Vue.prototype.activityState = store.state.activityState //活动
Vue.prototype.doctorState = store.state.doctorState //医生/专家





Vue.prototype.errorMessage = (msg) => {
    Toast.fail({
        message: msg
    });
}




router.beforeEach((to, from, next) => {
    store.commit("setWechatSignUrl", getWechatSignUrl(to));
    const nextRoute = ['/question', '/complaints', '/writeDiary', '/addDiary', '/order'];
    const customer = store.state.customer;
    //先判断是否已获取微信openId
    if (!store.state.userInfo || !sessionStorage.getItem("ltmUserToken")) {
        getUserOpenId().then(res => {
            next();
        });
        //先判断进入的页面是否需要customer权限
    } else if (nextRoute.includes(to.path)) {
        //再判断是否customer权限
        if (!customer) {
            return next({
                path: "/login",
                query: { redirect: to.fullPath } //将跳转的路由path作为参数，登录成功后跳转到该路由
            });
        } else {
            next();
        }
    } else {
        next();
    }
})





let vue = new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})




function isIos() {
    const u = navigator.userAgent;
    return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
}


// 获取真实有效微信签名URL
function getWechatSignUrl(to) {
    if (isIos()) {
        return window.location.href;
    } else {
        // 此处$appHost需要自行处理
        // return $appHost + to.fullPath
        // Hxl 无所谓返回什么,在wechat.js中设置签名链接时有重新判断是否ios环境
        return '';
    }
}

export default vue;


// WEBPACK FOOTER //
// ./src/main.js